<template>
  <DragDialog
    title="数据发布记录"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="publish-record-box">
      <div class="table-box">
        <div class="filter-box">
          <div class="filter-item-box gr24">
            <div class="name dialog-label">发布平台：</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                v-model="platformId"
                size="small"
                filterable
                remote
                :remote-method="filterPlatForm"
                :loading="filterLoading"
                :popper-append-to-body="false"
                placeholder="请选择"
                @change="handlePlatFormChange">
                <div v-infinite-scroll="handleScroll">
                  <el-option
                    value="all"
                    label="所有"></el-option>
                  <el-option
                    v-for="(item, index) in platFormList"
                    :key="index"
                    :label="item.name"
                    :value="item.id" />
                </div>
              </el-select>
            </div>
          </div>
          <div class="filter-item-box gr24">
            <div class="name dialog-label">数据类型：</div>
            <div class="common-select-box">
              <el-cascader
                v-if="showCascader"
                class="primary-select"
                size="small"
                :append-to-body="false"
                popper-class="common-cascader-box"
                :options="dataTypeOptions"
                v-model="dataType"
                @change="handleCascaderChange"
                @visible-change="visibleChange" />
            </div>
          </div>
          <div class="filter-item-box gr24">
            <div class="name dialog-label">发布状态：</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                size="small"
                :popper-append-to-body="false"
                v-model="status"
                @change="handleStatusChange">
                <el-option
                  value="all"
                  label="所有"></el-option>
                <el-option
                  :value="2"
                  label="排队中"></el-option>
                <el-option
                  :value="0"
                  label="发布中"></el-option>
                <el-option
                  :value="1"
                  label="发布成功"></el-option>
                <el-option
                  :value="-1"
                  label="发布失败"></el-option>
              </el-select>
            </div>
          </div>
          <div class="common-input-box gr24">
            <el-input
              class="input-primary"
              size="small"
              placeholder="请输入名称搜索"
              v-model="name"
              clearable
              @clear="search"
              @keyup.enter.native="search"
              ><i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="search" />
            </el-input>
          </div>
        </div>
        <div class="publish-data-box">
          <div v-if="loading">
            <Spin
              :pointNum="8"
              :translateX="25"
              background="var(--base-primary-bgColor)" />
          </div>
          <div
            class="common-table-box"
            v-if="dataList.length && !loading">
            <el-table
              class="publish-table"
              highlight-selection-row
              height="100%"
              row-key="id"
              :data="dataList"
              ref="table"
              :header-row-class-name="customHeader">
              <el-table-column
                label="序号"
                type="index"
                width="75" />
              <el-table-column
                label="名称/大小"
                width="240">
                <template v-slot="{ row }">
                  <div
                    class="text-overflow"
                    :title="row.fileName">
                    {{ row.fileName }}
                  </div>
                  <div>
                    {{
                      `${formatFileSize(row.length).fileSize}${
                        formatFileSize(row.length).unit
                      }`
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="数据类型">
                <template v-slot="{ row }">
                  <span>{{ getDataType(row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="资源类型">
                <template v-slot="{ row }">
                  <span v-if="row.resourceType === 0">Windows</span>
                  <span v-if="row.resourceType === 1">MinIO</span>
                  <span v-if="row.resourceType === -1">--</span>
                </template>
              </el-table-column>
              <el-table-column
                label="发布状态"
                width="160">
                <template v-slot="{ row }">
                  <div
                    v-if="row.status === -1"
                    class="status-box">
                    <div class="circle bg-color3"></div>
                    <span class="color3">发布失败</span>
                    <el-tooltip
                      :effect="$theme.tooltipKey()"
                      placement="top-start"
                      popper-class="common-panel-tooltip-box">
                      <div slot="content">{{ row.failReason }}</div>
                      <div class="icon-box">
                        <i class="el-icon-warning"></i>
                      </div>
                    </el-tooltip>
                    <icon-svg
                      v-if="isChecked('Data.Migration.ExportPublish.Publish')"
                      title="重新发布"
                      class="icon"
                      icon-class="ic-zaicijiexi"
                      @click.native="rePublish(row)" />
                  </div>
                  <div
                    class="common-progress-box"
                    v-if="row.status === 0">
                    <el-progress
                      class="progress-primary"
                      :show-text="false"
                      :percentage="row.progress" />
                    <div class="custom-text">
                      <div class="text">{{ `${row.progress}%` }}</div>
                    </div>
                  </div>
                  <div
                    v-if="row.status === 1"
                    class="status-box">
                    <div class="circle bg-color4"></div>
                    <span class="color4">发布成功</span>
                  </div>
                  <div
                    v-if="row.status === 2"
                    class="status-box">
                    <div class="circle bg-color2"></div>
                    <span class="color2">排队中</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="所属项目">
                <template v-slot="{ row }">
                  <span>{{ row.srcProjectName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="目标平台">
                <template v-slot="{ row }">
                  <span>{{ row.publishPlatformName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="目标项目">
                <template v-slot="{ row }">
                  <span>{{ row.targetProjectName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="接收人">
                <template v-slot="{ row }">
                  <span>{{ row.targetOwnerName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="开始时间/完成时间"
                width="180">
                <template v-slot="{ row }">
                  <div>{{ formatTime(row.creationTime) }}</div>
                  <div v-if="row.status === 1">
                    {{
                      row.finishTime
                        ? formatTime(row.finishTime)
                        : formatTime(row.creationTime)
                    }}
                  </div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
            <div class="common-pagination-box">
              <el-pagination
                class="pagination-primary"
                popper-class="common-pagination-popper-box"
                layout="sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100, 150, 200]"
                :page-size="pageSize"
                :current-page="currPage"
                :total="total"
                @size-change="pageSizeChange"
                @current-change="pageChange">
              </el-pagination>
            </div>
          </div>
          <div
            class="common-empty-box"
            v-if="!dataList.length && !loading">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import Spin from '@/components/Spin.vue'
import DragDialog from '@/components/CustomDragDialog.vue'

import { Store } from '@/utils/store'
import { formatTime, formatFileSize } from '@/utils/generalMethods'

import {
  platformsService,
  publishListService,
  publishCheckService,
  rePublishService
} from '@/service/interface'

export default {
  data() {
    return {
      loading: false,
      platformId: undefined,
      filterLoading: false,
      platFormCurrPage: 1,
      filterName: '',
      platFormList: [],
      dataType: undefined,
      publishType: undefined,
      status: undefined,
      name: '',
      dataTypeOptions: [
        { value: 'all', label: '所有' },
        { value: 0, label: '项目信息' },
        {
          value: 'dataSet',
          label: '数据集',
          children: [
            { value: 'allDataSet', label: '全部' },
            { value: 'Model', label: '模型' },
            { value: 'ModelGroup', label: '模型组' },
            { value: 'Rs', label: '遥感影像' },
            { value: 'Wmts', label: 'WMTS' },
            { value: 'Osgb', label: '倾斜摄影' },
            { value: 'Panorama', label: '360全景图' },
            { value: 'PointCloud', label: '点云' },
            { value: 'Cad', label: '二维图纸' },
            { value: 'Vector', label: '矢量数据' }
          ]
        },
        { value: 1, label: '场景' }
      ],
      dataList: [],
      pageSize: 10,
      currPage: 1,
      total: 0,
      customHeader: '',
      showCascader: true
    }
  },
  props: {
    visible: Boolean,
    closeDialog: Function
  },
  components: {
    DragDialog,
    Spin
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initPlatFormList()
        this.initPublishList()
      }
    }
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs?.table?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 1500)
  },
  methods: {
    initPlatFormList() {
      this.queryPlatFormList().then(response => {
        let { dataList } = response
        this.platFormList = dataList
      })
    },
    initPublishList() {
      this.loading = true
      this.queryPublishList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total

        this.timer && clearInterval(this.timer)
        let publishingStatus = [0, 2]
        let publishingData = dataList.filter(el =>
          publishingStatus.includes(el.status)
        )
        if (publishingData.length) {
          this.timer = setInterval(this.refreshPublishList, 5 * 1000)
        }

        this.loading = false
      })
    },
    handlePlatFormChange() {
      this.currPage = 1
      this.initPublishList()
    },
    visibleChange(flag) {
      if (flag) return
      this.showCascader = false
      this.$nextTick(() => {
        this.showCascader = true
      })
    },
    handleCascaderChange(dataType) {
      if (dataType.length === 1) {
        let value = dataType[0]
        this.publishType = value
      }
      if (dataType.length === 2) {
        let value = dataType[1]
        this.publishType = value
      }
      this.currPage = 1
      this.initPublishList()
    },
    handleStatusChange() {
      this.currPage = 1
      this.initPublishList()
    },
    search() {
      this.currPage = 1
      this.initPublishList()
    },
    refreshPublishList() {
      this.queryPublishList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total

        let publishingStatus = [0, 2]
        let publishingData = dataList.filter(el =>
          publishingStatus.includes(el.status)
        )
        if (publishingData.length) {
          this.timer && clearInterval(this.timer)
          this.timer = null
          this.timer = setInterval(this.refreshPublishList, 5 * 1000)
        } else {
          this.timer && clearInterval(this.timer)
          this.timer = null
        }
      })
    },
    rePublish(publishInfo) {
      console.log(publishInfo, '参数')

      this.rePublishCheck(publishInfo).then(checkResult => {
        let exportIds = [publishInfo.exportId]
        this.handleExceptionFiles(checkResult, exportIds).then(
          validExportIds => {
            if (validExportIds.length) {
              let id = publishInfo.id
              rePublishService(id).then(response => {
                if (response.isSuccess) {
                  this.refreshPublishList()
                } else {
                  this.$message.error(response.errMsg)
                }
              })
            }
          }
        )
      })
    },
    rePublishCheck(publishInfo) {
      return new Promise(resolve => {
        let params = this.getCheckParams(publishInfo)
        publishCheckService(params).then(response => {
          let jumpFiles = []
          let overwriteFiles = []

          if (response.isSuccess) {
            let data = response.data
            let { unEffectiveItems, acknowledgedItems } = data
            if (unEffectiveItems) {
              unEffectiveItems.forEach(item => {
                let find = jumpFiles.find(
                  el =>
                    el.exportType === item.exportType &&
                    el.errorMsg === item.errorMsg
                )
                if (find) {
                  find.files.push({ id: item.id, fileName: item.fileName })
                } else {
                  let obj = {
                    exportType: item.exportType,
                    errorMsg: item.errorMsg,
                    files: [{ id: item.id, fileName: item.fileName }]
                  }
                  jumpFiles.push(obj)
                }
              })
            }

            if (acknowledgedItems) {
              acknowledgedItems.forEach(item => {
                let find = overwriteFiles.find(
                  el => el.exportType === item.exportType
                )
                if (find) {
                  find.files.push({ id: item.id, fileName: item.fileName })
                } else {
                  let obj = {
                    exportType: item.exportType,
                    files: [{ id: item.id, fileName: item.fileName }]
                  }
                  overwriteFiles.push(obj)
                }
              })
            }

            resolve({ jumpFiles, overwriteFiles })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    handleExceptionFiles(exceptionFile, exportIds) {
      return new Promise(resolve => {
        let { jumpFiles, overwriteFiles } = exceptionFile

        if (!jumpFiles.length && !overwriteFiles.length) {
          resolve(exportIds)
          return
        }

        let find = jumpFiles.find(el => el.exportType === 0)
        if (find) {
          this.$confirm(find.errorMsg, '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false
          }).then(() => {
            resolve([])
          })
          return
        }

        let invalidIds = []
        let msgTips = []
        let msgTail = ''
        let dataTypeNames = ['项目信息', '场景', '数据集']
        jumpFiles.forEach(item => {
          let ids = item.files.map(el => el.id)
          invalidIds = [...invalidIds, ...ids]
          msgTips.push(`${item.files.length}个${item.errorMsg}`)
        })
        if (msgTips.length > 1) {
          msgTips = msgTips.map((item, index) => {
            return `${index + 1}、${item}`
          })
        }

        if (!jumpFiles.length) {
          let msgArray = []
          overwriteFiles = overwriteFiles.sort(
            (obj1, obj2) => obj1.exportType - obj2.exportType
          )
          overwriteFiles.forEach(item => {
            if (item.exportType === 0) {
              msgArray.push('项目信息已存在')
            } else {
              let msg = `${item.files.length}个${
                dataTypeNames[item.exportType]
              }在当前项目中已存在`
              msgArray.push(msg)
            }
          })
          let warningMsg = `${msgArray.join('、')},是否覆盖`
          this.$confirm(warningMsg, '提示', {
            iconClass: 'null',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              resolve(exportIds)
            })
            .catch(() => {
              this.$message.info('取消发布')
            })
          return
        }

        if (this.isAllJumpFiles(exportIds, jumpFiles)) {
          let message = this.createHtml(msgTips, msgTail)
          this.$confirm(message, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false
          }).then(() => {
            resolve([])
          })
          return
        } else {
          if (overwriteFiles.length) {
            let msgArray = []
            overwriteFiles = overwriteFiles.sort(
              (obj1, obj2) => obj1.exportType - obj2.exportType
            )
            overwriteFiles.forEach(item => {
              if (item.exportType === 0) {
                msgArray.push('已存在的项目信息')
              } else {
                let msg = `在当前项目中已存在的${item.files.length}个${
                  dataTypeNames[item.exportType]
                }`
                msgArray.push(msg)
              }
            })
            let msgTail = `是否跳过继续发布，并对${msgArray.join('、')}进行覆盖`
            let message = this.createHtml(msgTips, msgTail)
            this.$confirm(message, '提示', {
              dangerouslyUseHTMLString: true,
              iconClass: 'null',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                invalidIds.forEach(item => {
                  let findIndex = exportIds.findIndex(el => item === el)
                  if (findIndex !== -1) {
                    exportIds.splice(findIndex, 1)
                  }
                })
                resolve(exportIds)
              })
              .catch(() => {
                this.$message.info('取消发布')
              })
            return
          } else {
            let message = this.createHtml(msgTips, '是否跳过继续发布')
            this.$confirm(message, '提示', {
              dangerouslyUseHTMLString: true,
              iconClass: 'null',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                invalidIds.forEach(item => {
                  let findIndex = exportIds.findIndex(el => item === el)
                  if (findIndex !== -1) {
                    exportIds.splice(findIndex, 1)
                  }
                })
                resolve(exportIds)
              })
              .catch(() => {
                this.$message.info('取消发布')
              })
          }
        }
      })
    },
    isAllJumpFiles(exportIds, jumpFiles) {
      let count = 0
      jumpFiles.forEach(item => {
        count += item.files.length
      })
      if (count === exportIds.length) {
        return true
      } else {
        return false
      }
    },
    getCheckParams(publishInfo) {
      let {
        publishPlatformId,
        targetProjectId,
        targetProjectName,
        targetOwnerId,
        targetOwnerName,
        exportId
      } = publishInfo

      let params = {
        publishPlatformId,
        targetProjectId,
        targetProjectName,
        targetOwnerId,
        targetOwnerName,
        exportIds: [exportId]
      }
      return params
    },
    cancel() {
      this.platformId = undefined
      this.dataType = undefined
      this.publishType = undefined
      this.status = undefined
      this.name = ''
      this.currPage = 1
      this.pageSize = 10

      this.timer && clearInterval(this.timer)
      this.timer = null

      this.closeDialog()
    },
    pageSizeChange(pageSize) {
      this.currPage = 1
      this.pageSize = pageSize
      this.initPublishList()
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.initPublishList()
    },
    handleScroll() {
      if (this.allEpsgLoaded) return
      this.platFormCurrPage++
      this.queryPlatFormList().then(response => {
        let { dataList } = response
        if (dataList.length) {
          this.platFormList = [...this.platFormList, ...dataList]
        } else {
          this.allEpsgLoaded = true
        }
      })
    },
    filterPlatForm(filterName) {
      this.platFormCurrPage = 1
      this.allEpsgLoaded = false
      this.filterName = filterName

      this.filterLoading = true
      this.queryPlatFormList().then(response => {
        let { dataList } = response
        this.platFormList = dataList
        this.filterLoading = false
      })
    },
    queryPlatFormList() {
      return new Promise(resolve => {
        let params = {
          resultCount: 50,
          skipCount: (this.platFormCurrPage - 1) * 50,
          name: this.filterName
        }
        platformsService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            resolve({ dataList })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryPublishList() {
      return new Promise(resolve => {
        let params = this.getQueryParams()
        publishListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            dataList.forEach(el => {
              el.progress = Number((el.progress * 100).toFixed(2))
            })
            let total = data.totalCount
            resolve({ dataList, total })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    createHtml(msgTips, msgTail) {
      let htmlString = '<div>'
      msgTips.forEach(item => {
        htmlString += `<p>${item}</p>`
      })
      htmlString += `<p>${msgTail}</p>`
      htmlString += '</div>'
      return htmlString
    },
    getQueryParams() {
      let params = {
        platformId: this.platformId === 'all' ? undefined : this.platformId,
        status: this.status === 'all' ? undefined : this.status,
        name: this.name,
        resultCount: this.pageSize,
        skipCount: (this.currPage - 1) * this.pageSize
      }
      switch (this.publishType) {
        case 'all':
          params.publishType = undefined
          break
        case 0:
        case 1:
          params.publishType = this.publishType
          break
        case 'allDataSet':
          params.publishType = 2
          break
        case 'Model':
          params.publishType = 2
          params.scheme = 'Bim'
          params.formatType = 1
          break
        case 'ModelGroup':
          params.publishType = 2
          params.scheme = 'Bim'
          params.formatType = 2
          break
        case 'Rs':
        case 'Wmts':
        case 'Osgb':
        case 'Panorama':
        case 'PointCloud':
        case 'Cad':
        case 'Vector':
          params.publishType = 2
          params.scheme = this.publishType
          // params.formatType = 1;
          break
      }

      return params
    },
    getDataType(publishInfo) {
      let dataTypeDes = ''
      let publishType = publishInfo.publishType
      let scheme = publishInfo.scheme
      let formatType = publishInfo.formatType
      switch (publishType) {
        case 0:
          dataTypeDes = '项目信息'
          break
        case 1:
          dataTypeDes = '场景'
          break
        case 2:
          if (scheme === 'Bim') {
            if (formatType === 1) {
              dataTypeDes = '模型'
            } else {
              dataTypeDes = '模型组'
            }
          } else if (scheme === 'Rs') {
            dataTypeDes = '遥感影像'
          } else if (scheme === 'Wmts') {
            dataTypeDes = 'WMTS'
          } else if (scheme === 'Osgb') {
            dataTypeDes = '倾斜摄影'
          } else if (scheme === 'Panorama') {
            dataTypeDes = '360全景图'
          } else if (scheme === 'PointCloud') {
            dataTypeDes = '点云'
          } else if (scheme === 'Cad') {
            dataTypeDes = '二维图纸'
          } else if (scheme === 'Vector') {
            dataTypeDes = '矢量数据'
          }
          break
      }
      return dataTypeDes
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime,
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.publish-record-box {
  display: flex;
  flex-direction: column;
  height: 500px;

  .table-box {
    height: 100%;
    flex-grow: 1;
    .filter-box {
      display: flex;
      justify-content: flex-start;
      .filter-item-box {
        display: flex;

        .name {
          // color: var(--default-color);
          line-height: 32px;
          white-space: nowrap;
        }

        // .common-select-box {
        //   width: 120px;
        // }
      }
    }

    .publish-data-box {
      height: calc(100% - 26px);
      .common-table-box {
        height: calc(100% - 70px);
        margin-top: 16px;

        .status-box {
          display: flex;
          font-size: 12px;

          .circle {
            width: 5px;
            height: 5px;
            margin: auto 5px auto 0px;
            border-radius: 50%;
          }

          .icon-box {
            margin: 0px 5px;
            color: var(--base-light-color10);
          }

          .icon {
            margin-right: 5px;
            line-height: 23px;
            cursor: pointer;
          }

          .bg-color1 {
            background: var(--table-cell-status-text-color);
          }

          .bg-color2 {
            background: var(--runing-status-color);
          }

          .bg-color3 {
            background: var(--error-status-color);
          }

          .bg-color4 {
            background: var(--success-status-color);
          }

          .color1 {
            color: var(--table-cell-status-text-color);
          }

          .color2 {
            color: var(--runing-status-color);
          }

          .color3 {
            color: var(--error-status-color);
          }

          .color4 {
            color: var(--success-status-color);
          }
        }

        .common-progress-box {
          display: flex;

          .el-progress {
            width: 40%;
          }

          .custom-text {
            width: 60px;
            line-height: 12px;
            font-size: 12px;
            text-align: center;

            .text {
              color: var(--success-status-color);
            }
          }

          &:hover {
            .custom-text {
              display: block;
            }
          }
        }

        .common-pagination-box {
          text-align: center;
        }
      }

      .common-empty-box {
        color: var(--normal-status-color);
      }
    }
  }

  .common-button-box {
    margin-top: 16px;
    text-align: right;
  }
}
</style>
